import flowRight from 'lodash/flowRight';
import React, { createContext } from 'react';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { INITIAL_BOOKING_ROOT_KEY } from '../../constants';
import useCreateUsernameForm from './useCreateUsernameForm';

export const CreateUsernameFormContext = createContext();

/**
 *
 * @param {JSX.Element} children
 * @param {function} goBackToPatientInfo
 * @param {function} onSubmitSuccess
 * @param {function} sendMetric
 * @returns {JSX.Element}
 * @constructor
 */
const CreateUsernameFormProvider = ({
    children,
    goBackToPatientInfo,
    onSubmitSuccess,
    sendMetric,
}) => {
    const createUsernameForm = useCreateUsernameForm({
        goBackToPatientInfo,
        onSubmitSuccess: onSubmitSuccess,
        sendMetric,
    });

    return (
        <CreateUsernameFormContext.Provider value={createUsernameForm}>
            {children}
        </CreateUsernameFormContext.Provider>
    );
};

const mapStateToProps = (state = {}) => {
    const bookingPage = state[INITIAL_BOOKING_ROOT_KEY];

    return {
        directoryId: bookingPage?.directoryId,
    };
};

export default flowRight(
    connect(mapStateToProps),
    withCustomMetrics({
        category: 'Booking - Create Username',
        page: 'Booking',
        section: 'Create Username View',
        component: 'Create Username Form',
        element: 'Create Username Form',
    })
)(CreateUsernameFormProvider);
